module.exports = __webpack_public_path__ + "img/entrees.f4cf4048.svg";